import React from "react";
import "./Testimonials.css";

const QuoteIcon = () => (
  <svg viewBox="0 0 24 24" className="testimonial-quote" aria-hidden="true">
    <path
      fill="currentColor"
      d="M10.6 10.1c0-3.6 2.1-6.1 5.5-7.1l.8 2.3c-2.3.9-3.2 2.2-3.3 3.9 1.7 0 3.2 1.4 3.2 3.3 0 2-1.6 3.6-3.7 3.6-1.8 0-3.5-1.5-3.5-3.9Zm-9 0c0-3.6 2.1-6.1 5.5-7.1l.8 2.3c-2.3.9-3.2 2.2-3.3 3.9 1.7 0 3.2 1.4 3.2 3.3 0 2-1.6 3.6-3.7 3.6C1.9 16.1.2 14.6.2 12.2Z"
    />
  </svg>
);

const Star = ({ filled }) => (
  <svg viewBox="0 0 24 24" className={`testimonial-star ${filled ? "filled" : ""}`} aria-hidden="true">
    <path
      d="M12 2.7l2.7 5.5 6.1.9-4.4 4.3 1 6.1L12 16.8l-5.4 2.7 1-6.1-4.4-4.3 6.1-.9L12 2.7z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="1"
    />
  </svg>
);

const StarRating = ({ rating }) => {
  const fullStars = Math.round(rating);
  return (
    <div className="star-rating" aria-label={`${rating} out of 5 stars`}>
      {[1, 2, 3, 4, 5].map((i) => (
        <Star key={i} filled={i <= fullStars} />
      ))}
      <span className="rating-value">{rating.toFixed(1)}</span>
    </div>
  );
};

const TESTIMONIALS = [
  {
    name: "Angela K.",
    initials: "AK",
    date: "",
    rating: 5,
    text: "Absolutely gorgeous apartments. My friend lives there and is so happy with the decision to make the moves into the lofts. Great views of the city!!",
  },
  {
    name: "Angler D.",
    initials: "AD",
    date: "",
    rating: 4.8,
    text: "Lived here in a loft facing the back. Super quiet, great management, awesome building superintendent and parking in the building. All this and a one minute walk to El Gaucho....what's to think about? I would live here again in a heartbeat, if I am ever back in Tacoma.",
  },
  {
    name: "Brandon B.",
    initials: "BB",
    date: "",
    rating: 4.7,
    text: "I love the Harmon, the building was built in 1909 and it has the feel of Tacoma history inside. I live in a harbor side loft and love the view. Each loft has huge windows and one swings wide open. Suzanne is the property manager and from the the first day I met her she has been fantastic. All around it is a great place to call home.",
  },
];

export default function Testimonials({
  heading = "What our clients say",

}) {
  return (
    <section className="testimonials-section">
      <div className="testimonials-container">
        <div className="testimonials-header">
          <div className="testimonials-heading-wrapper">
            <h2 className="testimonials-title">
              {heading}
            </h2>
            <div className="testimonials-underline" aria-hidden="true"></div>
          </div>
        
        </div>

        <div className="testimonials-grid">
          {TESTIMONIALS.map((testimonial, index) => (
            <article className="testimonial-card" key={index}>
              <div className="testimonial-card-inner">
                <div className="card-header">
                  <div className="rating-container">
                    <StarRating rating={testimonial.rating} />
                    <span className="review-date">{testimonial.date}</span>
                  </div>
                  <QuoteIcon />
                </div>

                <div className="card-content">
                  <p className="testimonial-text">{testimonial.text}</p>
                </div>

                <div className="card-footer">
                  <div className="client-avatar" aria-hidden="true">
                    <span>{testimonial.initials}</span>
                  </div>
                  <div className="client-info">
                    <h3 className="client-name">{testimonial.name}</h3>
                    <span className="client-status">Verified Tenant</span>
                  </div>
                </div>
              </div>
            </article>
          ))}
        </div>
        
        <div className="testimonials-indicators">
          {TESTIMONIALS.map((_, index) => (
            <button key={index} className="indicator" aria-label={`Go to testimonial ${index + 1}`}></button>
          ))}
        </div>
      </div>
    </section>
  );
}
